import { Box, Text } from '@salestrak/ui'
import type { Omittable } from "@salestrak/ui";

type SectionProps = Omittable<{
  title: string
  subtitle?: string
  titleExtra?: React.ReactNode
  onClick?: () => void
  children: React.ReactNode
}>;

export function Section({ title, subtitle, titleExtra, onClick, children }: SectionProps) {
  return (
    <Box rounded="xl" border padding="md" surface="card" onClick={onClick}>
      <Box direction="row" gap="xs" align="center">
        <Text size="sm" weight="medium" variant="muted">{title}</Text>
        {titleExtra}
      </Box>
      {subtitle && (
        <Box paddingTop="xs">
          <Text size="xs" variant="muted">{subtitle}</Text>
        </Box>
      )}
      <Box paddingTop="sm">{children}</Box>
    </Box>
  )
}
